import { lazy } from 'react';
import './icon.scss';

/* lazy has some limittation, here why I implemented this util https://github.com/reactjs/rfcs/pull/64#discussion_r226683684  */
const lazyIcon = (iconListImport, iconName) => {
  return lazy(() => iconListImport.then((module) => ({ default: module[iconName] })));
};

export { lazyIcon };
